import { render, staticRenderFns } from "./bidComplaint.vue?vue&type=template&id=2e577c79&scoped=true"
import script from "./bidComplaint.vue?vue&type=script&lang=js"
export * from "./bidComplaint.vue?vue&type=script&lang=js"
import style0 from "./bidComplaint.vue?vue&type=style&index=0&id=2e577c79&prod&lang=less&scoped=true"
import style1 from "./bidComplaint.vue?vue&type=style&index=1&id=2e577c79&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e577c79",
  null
  
)

export default component.exports